import { graphql } from "react-relay";

export const UpdateOnboardingTaskStatusMutation = graphql`
  mutation UpdateOnboardingTaskStatusMutation($input: UpdateOnboardingTaskStatusInput!) {
    updateOnboardingTaskStatus(input: $input) {
      taskStatus {
        id
        taskId
        status
        completedAt
        completedByUser {
          id
          firstName
          lastName
        }
      }
    }
  }
`;